export default __webpack_public_path__ + "static/media/colors.5e5fd390.png";